import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e5dd562"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pay-modal" }
const _hoisted_2 = { class: "pay-modal-body" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "选择支付方式", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slogan" }, [
  /*#__PURE__*/_createTextVNode(" 支持使用格布小包余额支付 "),
  /*#__PURE__*/_createElementVNode("span", null, "支付前请您仔细核对收件人信息和包裹打包图片")
], -1))
const _hoisted_6 = { class: "left-menu" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "优惠券", -1))
const _hoisted_8 = { class: "right-menu" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "use-coupon"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "payment" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["value", "checked", "disabled"]
const _hoisted_15 = { class: "g-radio label-content" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "label" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_20 = { class: "picker-dialog" }
const _hoisted_21 = { class: "header" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "优惠券", -1))
const _hoisted_23 = { class: "close-btn" }
const _hoisted_24 = {
  key: 0,
  class: "coupon-wrapper"
}
const _hoisted_25 = { class: "card-left" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "coupon-title" }, "优惠券", -1))
const _hoisted_27 = { class: "card-right" }
const _hoisted_28 = { class: "card-info" }
const _hoisted_29 = { class: "card-time" }
const _hoisted_30 = ["value", "checked", "onChange"]
const _hoisted_31 = {
  key: 1,
  class: "empty-coupon"
}
const _hoisted_32 = { class: "el-overlay-dialog" }
const _hoisted_33 = {
  class: "el-dialog",
  "aria-modal": "true",
  role: "dialog",
  "aria-label": "扫码支付",
  style: {"--el-dialog-width":"340px"}
}
const _hoisted_34 = { class: "el-dialog__header" }
const _hoisted_35 = { class: "el-dialog__title" }
const _hoisted_36 = { class: "desc" }
const _hoisted_37 = { class: "el-dialog__body" }
const _hoisted_38 = { class: "qrcode" }
const _hoisted_39 = ["src"]
const _hoisted_40 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Icon, {
          class: "icon pay-modal-close",
          onClick: _ctx.closeModal,
          icon: "btn_cancel"
        }, null, 8, ["onClick"]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", {
            class: "coupon",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCoupon && _ctx.openCoupon(...args)))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", null, [
                _createVNode(_component_Icon, {
                  class: "icon coupon-icon",
                  icon: "quan"
                }),
                _hoisted_7
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.hasCoupon && !_ctx.selectCoupon.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, "您有优惠券可使用"))
                : (_ctx.selectCoupon.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.selectCoupon.coupon_type == 'Free'
                  ? '抵扣券'
                  : '减' + _ctx.selectCoupon.coupon_amount + '元'), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, "暂无可用券")),
              _createVNode(_component_Icon, {
                class: "icon arrow-right",
                icon: "btn_arrow_right"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payment, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["form-item-checkbox", { disable: item.disabled }]),
                onClick: ($event: any) => (_ctx.changePayment(item)),
                key: item.id
              }, [
                _createElementVNode("input", {
                  type: "radio",
                  value: item.id,
                  checked: _ctx.selectPayment == item.id,
                  disabled: item.disabled
                }, null, 8, _hoisted_14),
                _createElementVNode("label", _hoisted_15, [
                  _createElementVNode("img", {
                    src: item.icon,
                    class: "icon"
                  }, null, 8, _hoisted_16),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(item.title) + _toDisplayString(item.note), 1)
                ])
              ], 10, _hoisted_13))
            }), 128))
          ]),
          _createElementVNode("div", {
            class: "ctrl",
            "hover-class": "hover",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startPay && _ctx.startPay(...args)))
          }, "立即支付")
        ])
      ])
    ]),
    (_ctx.showCoupons)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_Icon, {
                  class: "icon",
                  icon: "btn_cancel",
                  onClick: _ctx.hiddenCoupon
                }, null, 8, ["onClick"])
              ])
            ]),
            (_ctx.coupons.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coupons, (item, index) => {
                    return (_openBlock(), _createElementBlock("label", {
                      class: _normalizeClass(["coupon-card", { 'is-disabled': !item.availabled }]),
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_25, [
                        _createTextVNode(_toDisplayString(item.coupon_type === 'Free' ? '抵' : item.coupon_amount) + " ", 1),
                        _hoisted_26
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, _toDisplayString(item.coupon_name) + _toDisplayString(item.coupon_info ? '，' + item.coupon_info : item.coupon_info), 1),
                        _createElementVNode("div", _hoisted_29, "有效期至 " + _toDisplayString(item.expiration_time), 1),
                        (item.availabled)
                          ? (_openBlock(), _createElementBlock("input", {
                              key: 0,
                              class: "g-radio radio",
                              type: "radio",
                              value: item.coupon,
                              checked: _ctx.selectCoupon.id == item.id,
                              onChange: ($event: any) => (_ctx.changeCoupon(item))
                            }, null, 40, _hoisted_30))
                          : _createCommentVNode("", true)
                      ])
                    ], 2))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_31, "暂无优惠券可以使用"))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.paymentDialogForm.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "payment-dialog",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closePaymentDialog && _ctx.closePaymentDialog(...args)))
        }, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.paymentDialogForm.title) + "扫码支付", 1),
                _createElementVNode("span", _hoisted_36, " 使用" + _toDisplayString(_ctx.paymentDialogForm.title) + "扫一扫 ", 1)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  (_ctx.selectPayment == 'alipay')
                    ? (_openBlock(), _createElementBlock("iframe", {
                        key: 0,
                        width: "264",
                        height: "264",
                        frameborder: "no",
                        border: "0",
                        marginwidth: "0",
                        marginheight: "0",
                        scrolling: "no",
                        src: _ctx.paymentDialogForm.qrcode,
                        seamless: ""
                      }, null, 8, _hoisted_39))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _ctx.paymentDialogForm.qrcode
                      }, null, 8, _hoisted_40))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}